import { Route } from "react-router-dom";
import Terminanfrage from "../pages/kontakt/terminanfrage";
import Rezeptbestellung from "../pages/kontakt/rezeptbestellung";


const KontaktRoutes = [
    <Route path="/kontakt/terminanfrage" element={<Terminanfrage />} />,
    <Route path="/kontakt/rezeptbestellung" element={<Rezeptbestellung />} />
]
    
export default KontaktRoutes;
